module.exports = __webpack_public_path__ + "fbc953e4ff249a9dd7d11b19d2c50ed7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/wall_items/television.png
// module id = 1609
// module chunks = 0